import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { features, queryClient as qc } from 'keys'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import { getGradesFetch, getSchoolClassesFetch, getTestTakerFetch, getTestTakersFetch, getTestTakersOptionsFetch, getWithLastAssessmentsFetch, getAllGradesFetch, getLanguagesFetch } from "store/middlewares/testTakers.crud"
import { convertSelectToValue } from "utils/formatter"
import { getAffiliationsFetch } from "store/middlewares/affiliation.crud"
import { useContext } from "react"
import { AbilityContext } from "components/Permissions/Can"

//get test_taker by ID
const useGetTestTaker = () => {
    const dispatch = useDispatch()
    const { testTaker } = useSelector(state => state.testTaker)
    const params = useParams()
    const testTakerID = isEmpty(testTaker) ? params.testTakerID : testTaker.test_taker_id

    return useQuery(
        {
            queryKey: [qc.testTaker, testTakerID],
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            refetchOnMount: false,
            refetchInterval: false,
            queryFn: async ({ signal }) => {
                const { data } = await getTestTakerFetch(testTakerID)
                dispatch(actions.setTestTaker(data))
            }
        })
}

//get classes by params
const useGetSchoolClassess = (formValues) => {
    const dispatch = useDispatch()
    const { headerFilters } = useSelector(state => state.header)
    let group, affiliation, grade

    const filterValues = formValues || headerFilters

    if (filterValues) {
        group = convertSelectToValue(filterValues.group)
        affiliation = convertSelectToValue(filterValues.affiliation)
        grade = convertSelectToValue(filterValues.grade)
    }

    return useQuery({
        queryKey: [qc.schoolClassess],
        queryFn: () => getSchoolClassesFetch(
            convertSelectToValue(filterValues)
        ),
        enabled: false
    })
}

//get affiliation by params
const useGetAffiliations = (formValues) => {
    const dispatch = useDispatch()
    const { headerFilters } = useSelector(state => state.header)
    let group, affiliation

    const filterValues = formValues || headerFilters

    if (filterValues) {
        group = convertSelectToValue(filterValues.group)
        affiliation = convertSelectToValue(filterValues.affiliation)
    }

    return useQuery({
        queryKey: [qc.schoolClassess],
        queryFn: async () => {
            const { data } = await getAffiliationsFetch(
                convertSelectToValue(filterValues)
            )
            dispatch(actions.setAffiliations(data))
        },
        enabled: false
    })
}

//get grades by params
const useGetGrades = ({ enabled, formValues }) => {
    const { headerFilters } = useSelector(state => state.header)
    let group, affiliation

    const filterValues = formValues || headerFilters

    if (filterValues) {
        group = convertSelectToValue(filterValues.group)
        affiliation = convertSelectToValue(filterValues.affiliation)
    }

    return useQuery({
        queryKey: [qc.grades],
        queryFn: async () => {
            const { data } = await getGradesFetch(
                convertSelectToValue(filterValues)
            )
            return data
        },
        enabled: enabled ? enabled : false,
    })
}

const useGetAllGrades = () => {
    return useQuery({
        queryKey: [qc.allGrades],
        queryFn: async () => {
            const { data } = await getAllGradesFetch()
            return data
        },
    })
}

const useGetTestTakersOptions = () => {
    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)

    const { headerFilters } = useSelector(state => state.header)
    const canReadTestTaker = ability.can('read', features.test_taker)

    return useQuery({
        queryKey: [
            qc.testTakersOptions,
            // headerFilters?.group?.id || "group",
            // headerFilters?.affiliation?.id || "affiliation",
            // headerFilters?.grade?.id || "grade",
            // headerFilters?.learning_unit?.id || "learning_unit"
        ],
        queryFn: async () => {
            if (canReadTestTaker) {
                const { data } = await
                    getTestTakersOptionsFetch(
                        convertSelectToValue(headerFilters))
                dispatch(actions.setTestTakers(data))
                return data
            }
            return null
        },
        enabled: false,
        staleTime: Infinity,
        refetchOnWindowFocus: false
    })
}

export default { useGetAllGrades, useGetAffiliations, useGetGrades, useGetTestTaker, useGetSchoolClassess, useGetTestTakersOptions }